import { ClientAddress } from "@/types/ClientAddress";
import { RegistrationData } from "@/types/RegistrationData";
import { Veiculo } from "@/types/Veiculo";
import { useState } from "react";
import TabEnderecos from "./tab-addresses";

import TabDados from "./tab-data";
import TabVeiculos from "./tab-vehicles";

const tabs = [
  { label: "Dados pessoais", id: "dados" },
  { label: "Veículos", id: "veiculos" },
  { label: "Endereços", id: "enderecos" },
];

interface PersonalTabsProps {
  vehicles: Veiculo[];
  addresses: ClientAddress[];
  registrationData: RegistrationData | null;
}

export default function PersonalTabs({
  vehicles,
  addresses,
  registrationData,
}: PersonalTabsProps) {
  const [active, setActive] = useState<string>("dados");

  return (
    <div className="flex flex-col gap-6  rounded-[20px] ">
      <div className="flex gap-3">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActive(tab.id)}
            className={`px-3 py-1.5 rounded-full text-sm font-semibold transition-colors duration-300 ${
              active === tab.id
                ? "bg-n-green-s-light text-n-text-green hover:bg-n-green-s-light/60"
                : "bg-n-bg-3 text-n-text-neutral hover:bg-n-neutral-lighter/80"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {active === "dados" && <TabDados registrationData={registrationData} />}
      {active === "veiculos" && <TabVeiculos itens={vehicles} />}
      {active === "enderecos" && <TabEnderecos itens={addresses} />}
    </div>
  );
}
